export default __webpack_public_path__ + "static/media/RecipientIcon.b36dcad4.png";